import { AuthRouteKeys, MainRouteKeys } from 'routes/enums';
import * as Yup from 'yup';

export const formSchema = (requirePass = true) => [
  {
    name: 'phoneNumber',
    validate: Yup.number()
      .typeError('Số điện thoại không hợp lệ')
      .min(10, 'Số điện thoại không được ít hơn 10 chữ số'),
  },
  {
    name: 'pinCode',
    ...(requirePass && {
      validate: Yup.string()
        .matches(/[0-9]/, 'Mật khẩu phải là số')
        .test(
          'len',
          'Mật khẩu phải đủ 6 kí tự',
          (val) => val?.toString().length === 6,
        ),
    }),
  },
];

export enum LoginStatusSuccess {
  SUCCESS = 200,
  SUCCESS_WITHOUT_PASSWORD = 201,
}

export const LoginStatusSuccessDefined = {
  [LoginStatusSuccess.SUCCESS]: {
    message: 'Đăng nhập thành công',
    path: MainRouteKeys.Root,
  },
  [LoginStatusSuccess.SUCCESS_WITHOUT_PASSWORD]: {
    message: 'Bạn chưa có mật khẩu, vui lòng tạo mật khẩu mới',
    path: AuthRouteKeys.NewPassword,
  },
};
